{
  "intro": "Network disks of the project: 10\u00a0GB to 10\u00a0TB of storage that attaches to a server in the same location and outlives it. A volume is billed for its whole size every month, attached or not; it can grow but never shrink.",
  "empty": "No volumes yet",
  "emptyLead": "A volume gives a server space beyond its own disk: for databases, files, backups. Its data stays when the server is rebuilt or deleted.",
  "create": "Create volume",
  "createLead": "A new volume in a location, or straight on a server.",
  "createSubmit": "Create volume",
  "created": "Volume {{name}} is being created",
  "name": "Name",
  "nameHint": "Letters, digits, dots, hyphens and underscores, up to 64 characters.",
  "size": "Size, GB",
  "sizeHint": "From {{min}} to {{max}}\u00a0GB. Later the size can only grow.",
  "sizeGb": "{{size}}\u00a0GB",
  "priceLine": "{{price}} per month: {{size}}\u00a0GB × {{perGb}} per GB.",
  "billing": "A volume is billed from creation until deletion — for its whole size, attached to a server or not. A deleted volume and its data cannot be brought back.",
  "where": "Where",
  "keepFree": "Create in a location, without a server",
  "onServer": "Attach to a server right away",
  "location": "Location",
  "locationHint": "The volume can only be attached to servers in this location.",
  "zone": "Network zone {{zone}}",
  "server": "Server",
  "chooseServer": "Choose a server",
  "serverHint": "A volume attaches to a server in the same location without powering it off. Up to {{max}} volumes per server.",
  "format": "File system",
  "formatNone": "No file system",
  "formatNoneHint": "An empty device: partition and format it on the server yourself.",
  "formatExt4Hint": "Fits almost everything.",
  "formatXfsHint": "For large files and databases.",
  "automount": "Mount automatically",
  "automountHint": "On Hetzner's system images the volume appears at /mnt/HC_Volume_<number>. Needs a file system.",
  "fs": "FS",
  "noFs": "none",
  "device": "Device",
  "notAttached": "Not attached",
  "creating": "Creating",
  "protected": "Protected",
  "flags": "Properties",
  "price": "Per month",
  "createdAt": "Created",
  "attach": "Attach to server",
  "attachTitle": "Attach {{name}} to a server",
  "attachLead": "The server must be in the same location ({{region}}). It does not need to be powered off. The server sees the volume as {{device}}.",
  "attaching": "Attaching {{name}}",
  "detach": "Detach from server",
  "detachTitle": "Detach {{name}} from {{server}}?",
  "detachUnmount": "Unmount the volume on the server first (umount), or the last writes may be lost.",
  "detachKept": "The data on the volume stays; you can attach it to another server in this location.",
  "detachBilling": "A detached volume is billed the same as an attached one.",
  "detaching": "Detaching {{name}}",
  "resize": "Increase size",
  "resizeTitle": "Increase {{name}}",
  "resizeLead": "Now {{size}}\u00a0GB. The size can only grow: a volume cannot be made smaller.",
  "newSize": "New size, GB",
  "newSizeHint": "More than {{size}}\u00a0GB, up to {{max}}\u00a0GB.",
  "newPrice": "{{price}} per month instead of {{old}}.",
  "resizeExt4": "Then grow the file system on the server: resize2fs {{device}}",
  "resizeXfs": "Then grow the file system on the server: xfs_growfs <mount point>",
  "resizeRaw": "Then grow the partitions and the file system on the server.",
  "resizeSubmit": "Increase",
  "resizing": "Increasing {{name}} to {{size}}\u00a0GB",
  "edit": "Name and labels",
  "editTitle": "Name and labels of {{name}}",
  "labels": "Labels",
  "labelsHint": "One per line: key=value.",
  "labelsInvalid": "Line {{line}}: key and value take up to 63 letters, digits, dots, hyphens and underscores.",
  "protect": "Turn on delete protection",
  "unprotect": "Turn off delete protection",
  "delete": "Delete",
  "deleteTitle": "Delete volume {{name}}?",
  "deleteData": "All data on the volume is destroyed and cannot be recovered.",
  "deleteBilling": "Billing for the volume stops.",
  "deleted": "Volume {{name}} deleted",
  "why": {
    "attached": "Already attached to {{server}}: detach it first.",
    "notAttached": "The volume is not attached.",
    "creating": "The volume is still being created.",
    "protected": "Delete protection is on: turn it off first.",
    "deleteAttached": "The volume is attached to a server: detach it first.",
    "otherRegion": "other location",
    "full": "already {{count}} volumes",
    "atMax": "A volume cannot be larger than {{max}}\u00a0GB."
  },
  "serverTab": {
    "title": "Volumes of the server",
    "lead": "Network disks attached to this server. Their data outlives rebuilding and deleting the server.",
    "empty": "No volume is attached to this server.",
    "attachExisting": "Attach volume",
    "createNew": "Create volume",
    "chooseVolume": "Free volume",
    "chooseVolumePlaceholder": "Choose a volume",
    "noneFree": "No free volumes in {{region}}. Create a new one.",
    "manage": "All volumes of the project",
    "mount": "Mounted at /mnt/HC_Volume_{{id}} when it was attached with automatic mounting."
  }
}
